// @flow

import React, { Component } from 'react';

import './RadioButton.css';

class RadioButton extends Component {
  render() {
    const { checked, id, label, filterName, onChange, value } = this.props;

    return (
      <span className="RadioButton">
        <input
          type="radio"
          name={filterName}
          id={id}
          value={value}
          checked={checked}
          onChange={onChange}
        />
        <label htmlFor={id}>
          {label}
        </label>
      </span>
    );
  }
}

export default RadioButton;



// WEBPACK FOOTER //
// ./src/components/RadioButtons/RadioButton.js